// The destination-room tabs both coldroom placement sheets carry. It was the
// same fifteen lines in each, and picking a room ALWAYS clears the destination
// — a cell code means nothing in a different room, and carrying one across is
// how a pallet gets recorded into a cell that is occupied somewhere else. That
// reset is the caller's, because only the caller knows what else the choice
// invalidates; this only guarantees it is asked for on every pick.
//
// Renders nothing on a single-room site, where there is no choice to make.

import clsx from 'clsx'

/** Just enough of a coldroom to name it. */
export interface RoomTab {
  coldroom_id: string
  code:        string
}

export default function DestinationRoomTabs({ rooms, value, onPick }: {
  rooms:  RoomTab[]
  value:  string
  onPick: (coldroomId: string) => void
}) {
  if (rooms.length <= 1) return null
  return (
    <div>
      <p className="text-[10px] uppercase tracking-wider text-muted mb-1.5">Destination coldroom</p>
      <div className="flex flex-wrap gap-1.5">
        {rooms.map(r => (
          <button key={r.coldroom_id} type="button"
            aria-pressed={value === r.coldroom_id}
            onClick={() => onPick(r.coldroom_id)}
            className={clsx(
              'tap-target-y rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors',
              value === r.coldroom_id
                ? 'bg-cyan-600 text-white'
                : 'surface text-fg-secondary hover:bg-raised',
            )}>
            {r.code}
          </button>
        ))}
      </div>
    </div>
  )
}
